export default (params, { location }) => {
  const { status } = location.query;
  return {
    ...params,
    count: 20,
    status: status !== 'ALL' ? status : null
  };
};



// WEBPACK FOOTER //
// ./webpack/routes/params/InvoiceListParams.js